import { useEffect } from "react";
import { useAppSelector } from "../redux/store";
import { syncNativeAuthState } from "../utilities/nativeBridge";

/** Keeps the native WebView shell aligned with persisted website auth. */
export default function NativeAuthSync() {
    const { isLoggedIn, refresh_token, user } = useAppSelector(
        (state) => state.auth
    );

    useEffect(() => {
        return syncNativeAuthState({
            isLoggedIn,
            refreshToken: refresh_token,
            role: user?.role,
        });
    }, [isLoggedIn, refresh_token, user?.role]);

    return null;
}
